import { useAnalyticsTracking } from '@/analytics/snowplow/AnalyticsTrackingContext';
import { useEmitUiEvent } from '@/analytics/snowplow/useEmitUIEvent';
import type { ConsultationWithPaymentStatus } from '@/components/PatientPageV2/hooks/useConsultationTabOverviewTable';
import type { Consultation } from '@/hooks/patients/usePatientConsultations';
import { useCallback } from 'react';

export const useConsultHistoryTracking = () => {
  const emitEvent = useEmitUiEvent();
  const { uiEvent } = useAnalyticsTracking();
  const contextId = uiEvent?.context_id;

  const trackViewConsultations = useCallback(
    (consultations: ConsultationWithPaymentStatus[]) => {
      const consultationIds = consultations.map(({ consultationId }) => consultationId.toString());

      emitEvent({
        component_name: 'ConsultHistoryTable',
        event_name: 'view_consult_history',
        id: 'view_consult_history',
        value: JSON.stringify(consultationIds),
        context_id: contextId,
      });
    },
    [emitEvent, contextId],
  );

  const trackViewConsultation = useCallback(
    (consultation: Consultation) => {
      emitEvent({
        component_name: 'ViewConsultButton',
        event_name: 'view_consult_detail',
        id: 'view_consult_detail',
        value: consultation.id.toString(),
        context_id: contextId,
      });
    },
    [emitEvent, contextId],
  );

  return {
    trackViewConsultations,
    trackViewConsultation,
  };
};
